import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import WhiteButton from "src/components/button/WhiteButton";
import { setGoogleDriveInstruction } from "src/redux/reducers/file-upload.reducer";
import { dispatch, useSelector } from "src/redux/store";
import { MuiButtonStyle } from "src/theme/buttonStyle";
import { GREY, PRIMARY, SECONDARY } from "src/theme/palette";

const AddInstruction = ({ setShowInstruction }) => {
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const {googleDriveInstruction} = useSelector(state => state.fileUpload);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const fileChangeHandler = (e) => {
    setUploadedFile(e.target.files[0] || null);
  };
  const onSelectHandler = () => {
    inputRef.current.focus();
  };
  const calculateInputHeight = () => {
    const lineHeight = 20;
    const lines = Math.ceil(inputValue.length / 76);
    return lineHeight * lines;
  };

  const onAddHandler = () => {
    if(inputValue || uploadedFile){
        dispatch(setGoogleDriveInstruction({
            instructionText:inputValue.trim(),instructionFile:uploadedFile
        }));
    }else{
      dispatch(setGoogleDriveInstruction({instructionText:'',instructionFile:null}));
    }
    setShowInstruction(false);
  };

  useEffect(()=>{
    if(googleDriveInstruction?.instructionText || googleDriveInstruction?.instructionFile){
        if(googleDriveInstruction?.instructionText)setInputValue(googleDriveInstruction?.instructionText);
        if(googleDriveInstruction?.instructionFile)setUploadedFile(googleDriveInstruction?.instructionFile);
    }
  },[]);
  
  return (
    <Box position={'absolute'} bottom={0} left={0} width={"100%"} backgroundColor={'#fff'} py="16px" px='24px' display={"flex"} flexDirection={"column"} gap="8px">
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography fontWeight={"bold"} fontSize={"14px"}>
          Add instructions
        </Typography>
        <Box
          onClick={() => setShowInstruction(false)}
          sx={{
            cursor: "pointer",
            p: "3px",
            "&:hover": {
              background: GREY[75],
              borderRadius: "10px",
              border: `1px solid ${GREY[75]}`,
            },
          }}
        >
          <img src="/images/cancel.svg" alt="" width="12px" height="12px" />
        </Box>
      </Box>
      <Box flex={1}>
        <Box
          sx={{
            minHeight: "99px",
            background: "#F9F9F9",
            borderRadius: "4px",
            width: "100%",
            p: "10px",
          }}
          onClick={onSelectHandler}
        >
          <textarea
            ref={inputRef}
            placeholder="Enter any special instructions for this project |"
            value={inputValue}
            onChange={handleInputChange}
            style={{
              fontSize: "12px",
              width: "100%",
              backgroundColor: "inherit",
              minHeight: "60px",
              height: `${calculateInputHeight()}px`,
              resize: "none",
              outline: "none",
              border: "none",
              "&:focus": { outline: "none", border: "none" },
            }}
          />
          <Box>
            {uploadedFile && (
              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "4px",
                  border: "1px solid #EEEEEE",
                  p: "10px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  width: "fit-content",
                }}
              >
                {uploadedFile.name}
                <img
                  src="/images/cancel.svg"
                  alt=""
                  width="10px"
                  height="10px"
                  style={{ cursor: "pointer" }}
                  onClick={() => setUploadedFile(null)}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box
          sx={{
            cursor: "pointer",
            p: "7px",
            border: `1px solid #fff`,
            "&:hover": {
              background: GREY[75],
              borderRadius: "20px",
              border: `1px solid ${GREY[75]}`,
            },
          }}
          onClick={() => fileInputRef.current.click()}
        >
          <img
            src="/icons/uploadFile/attach.svg"
            alt=""
            width={"16px"}
            height="16px"
          />
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={fileChangeHandler}
          />
        </Box>
        <Box display="flex" gap="30px">
          <WhiteButton
            sx={{ color: GREY[70], height: "38px" }}
            onClick={() => setShowInstruction(false)}
          >
            Cancel
          </WhiteButton>
          <Button
            sx={{
              ...MuiButtonStyle.grayColorButton,
              backgroundColor: SECONDARY.darker,
              color: PRIMARY.white,
              height: "38px",
              borderRadius: "29px",
              px: "28px",
            }}
            onClick={onAddHandler}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddInstruction;
